import { ProductStateInterface } from "./types";
import Customer from "@/types/customer/Customer";
import Investment from "@/types/app/investment";
import Notification from "@/types/app/notifications";
import Product from "@/types/app/products";
import Schedule from "@/types/app/schedules";

export default {
  
  setProductsState(state: ProductStateInterface, products: Product[]) {
    state.products = products;
  },
  setModalProductState(state: ProductStateInterface, show: boolean) {
    state.modalProduct = show;
  }, 
  setProductSent(state: ProductStateInterface, show: boolean) {
    state.productSent = show;
  }, 
  removeProduct(state: ProductStateInterface, id:string){
    state.products = state.products.filter(x => x.id !== id);
  },
  addNewProduct(state:ProductStateInterface, product:Product){
    state.products.push(product);
  }
};
